export default "__VITE_ASSET__BwGlFTBI__"